import { createAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { CART_DEFAULT_STATUS } from "../constants/status";
import { ICartDefault } from "../interface/ICart";
import { GetCartAvailableDateByAddressModel, GetCartDefaultModel } from "../model/cart";
import CartService from "../service/CartService";
import { RootState } from "../store/store";
import { logoutUser } from "./common";

export const resetCartDefault = createAction("cartdefault/reset")
const _service = new CartService();

type SliceState = { value: ICartDefault ,traderId?:number ,status:string ,apiCallCount:number} 
const initialState = {
  value: {},
  status: CART_DEFAULT_STATUS.INITIAL_DEFAULT,
  apiCallCount:0
} as SliceState;


export const getCartDefaultAsync = createAsyncThunk(
  "cartdefault/getCartDefAddressIdApi",
  async (params:GetCartDefaultModel) => {
    const response = await _service.getCartDefaultAddressService(params);
    return response;
  }
);

export const getCartAvailableDateByAddressAsync = createAsyncThunk(
  "cartdefault/getCartAvailDateByAddApi",
  async (params:GetCartAvailableDateByAddressModel) => {
    const response = await _service.getFirstAvailableDateByAddressService(params);
    return response;
  }
);


export const cartDefaultSlice = createSlice({
  name: "cartdefault",
  initialState,
  reducers:{
    updateCartDefaultStatus: (state: SliceState, action) => {
      state.status = action.payload;
    },
    updateCartDefault: (state: SliceState, action) => {
      state.value = action.payload;
      state.status = CART_DEFAULT_STATUS.LOADED_AVAIL_DATE;
    },
  },
  extraReducers: (builder) => {
    builder
      //Cart default Address
      .addCase(getCartDefaultAsync.pending, (state) => {
        state.status = CART_DEFAULT_STATUS.LOADING_DEFAULT;
      })
      .addCase(getCartDefaultAsync.fulfilled, (state, action:any) => {
        state.status = CART_DEFAULT_STATUS.LOADED_DEFAULT;
        state.value = {...state.value,defaultAddressId :action.payload, fromApi:true };
        state.apiCallCount =0;
      })
      .addCase(getCartDefaultAsync.rejected, (state) => {
        state.status = CART_DEFAULT_STATUS.FAILED_DEFAULT;
        state.apiCallCount +=1;
      })
      //Cart first Available date
      .addCase(getCartAvailableDateByAddressAsync.pending, (state) => {
        state.status = CART_DEFAULT_STATUS.LOADING_AVAIL_DATE;
      })
      .addCase(getCartAvailableDateByAddressAsync.fulfilled, (state, action:any) => {
        
        state.value = {...state.value,firstAvailableDate :  action.payload, fromApi:true};
        state.status = CART_DEFAULT_STATUS.LOADED_AVAIL_DATE;
        state.apiCallCount =0;
      })
      .addCase(getCartAvailableDateByAddressAsync.rejected, (state, action) => {
        state.status = CART_DEFAULT_STATUS.FAILED_AVAIL_DATE;
        state.apiCallCount +=1;
      })
      .addCase(logoutUser, () => {
        return initialState;
      })
      .addCase(resetCartDefault, () => {
        return initialState;
      });
  },
});

export const { updateCartDefaultStatus,updateCartDefault} = cartDefaultSlice.actions;

export const getCartDefault = (state:RootState) => state.cartdefault;
export const getCartDefaultInfo = (state:RootState) => state.cartdefault.value;
export const getCartDefaultStatus = (state:RootState) => state.cartdefault.status;
export const getCartTraderId = (state:RootState) => state.cartdefault.traderId;
export default cartDefaultSlice.reducer;